import React, {useEffect, useState} from 'react'
import {Link, useParams} from 'react-router-dom'
import {ModeleEtablissementClientSource} from '../../../../../../components/Models'
import {LoadingData} from '../../../../../../components/LoadingData'
import {getClientSourcesEtablissements} from '../../../../../../components/requests'
import {useAuth} from '../../../../../modules/auth'
import moment from 'moment'
import {Form} from 'react-bootstrap'
import {useFormik} from 'formik'
import {Pagination} from '../../../../../../components/Pagination'
import {Tooltip} from 'react-tooltip'

const ClientEtablissements = () => {
  let {clientId} = useParams()
  const [data, setData] = useState<Array<ModeleEtablissementClientSource>>([])
  const [loading, setLoading] = useState(true)
  const [actif, setActif] = useState(true)
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [searchSiret, setSearchSiret] = useState<string>('')
  const [isSearch, setIsSearch] = useState(false)
  const {currentUser} = useAuth()

  useEffect(() => {
    getEtablissementData()
  }, [currentPage, clientId, actif, searchSiret])

  const getEtablissementData = () => {
    setLoading(true)
    getClientSourcesEtablissements(!isSearch ? currentPage : 1, clientId, actif, searchSiret).then(
      (clientEtabRequest) => {
        setNombreDePages(clientEtabRequest?.pages)
        setTotalPages(clientEtabRequest?.total)
        setCurrentPage(clientEtabRequest?.page)
        if (clientEtabRequest?.data !== undefined) {
          setData(clientEtabRequest?.data)
          setLoading(false)
          setIsSearch(false)
        }
      }
    )
  }

  const formik = useFormik({
    initialValues: {siret: ''},
    onSubmit: (values, {setSubmitting}) => {
      setSearchSiret(values.siret)
    },
  })

  return (
    <>
      {loading ? (
        <LoadingData />
      ) : (
        <>
          <div className='card mb-5 mb-xl-10'>
            <div className='card-header border-0'>
              <div className='d-flex justify-content-between align-items-center w-100'>
                <h3 className='fw-bolder m-0'>Etablissement client</h3>
                <Form.Check type='checkbox' className='form-switch'>
                  <Form.Check.Input
                    className='me-2'
                    checked={actif}
                    onChange={() => setActif(!actif)}
                  />
                </Form.Check>
              </div>
            </div>
            <div
              className='d-flex justify-content-between align-items-center border-bottom-0'
              style={{minHeight: '50 px', paddingLeft: '2.25rem', paddingRight: '2.25rem'}}
            >
              <Link
                to={'/vente/client-sources'}
                data-tooltip-id='tooltip'
                data-tooltip-content='Revenir en arrière'
                data-tooltip-place='right'
              >
                <img src='/media/svg/custom/prev-arrow.svg' width={40} />
              </Link>
              <div className='d-flex gap-5'>
                {/* debut champs recherche */}
                <form onSubmit={formik.handleSubmit}>
                  {/* debut recherche par siret*/}
                  <div className='form-group d-flex ms-auto'>
                    <div className='input-group'>
                      <input
                        type='text'
                        className='form-control h-100'
                        {...formik.getFieldProps('siret')}
                        name='siret'
                        placeholder='Recherche par SIRET'
                      />
                      <button
                        type='submit'
                        className='btn btn-light border-0 input-group-append h-100'
                        onClick={() => setIsSearch(true)}
                      >
                        <i className='fas fa-search text-secondary fs-1'></i>
                      </button>
                    </div>
                  </div>
                  {/* fin recherche par siret*/}
                </form>
                {/* fin champs recherche */}
              </div>
            </div>
            <div>
              <div className='card-body p-9'>
                {/* begin::Table container */}
                <div className='table-responsive'>
                  {/* begin::Table */}
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    {/* begin::Table head */}
                    <thead>
                      <tr className='fw-bold text-muted'>
                        <th className='min-w-120px'>Type</th>
                        <th className='min-w-120px'>Siège</th>
                        <th className='min-w-120px'>Siret</th>
                        <th className='min-w-120px'>NIC</th>
                        <th className='min-w-120px'>Numéro voie</th>
                        <th className='min-w-120px'>Type voie</th>
                        <th className='min-w-120px'>Libellé voie</th>
                        <th className='min-w-120px'>Complément adresse</th>
                        <th className='min-w-120px'>Adresse Ligne 1</th>
                        <th className='min-w-120px'>Adresse Ligne 2</th>
                        <th className='min-w-120px'>Code postal</th>
                        <th className='min-w-120px'>Ville</th>
                        <th className='min-w-120px'>Code Naf</th>
                        <th className='min-w-120px'>Libellé code Naf</th>
                        <th className='min-w-100px text-end'>Date création</th>
                      </tr>
                    </thead>
                    {/* end::Table head */}

                    {/* begin::Table body */}
                    <tbody>
                      {data.length > 0 ? (
                        data.map((clientEtab) => {
                          return (
                            <tr key={clientEtab.id}>
                              <td>{clientEtab.typeEtablissement || '—'}</td>
                              <td>
                                <i
                                  className={`bi ${clientEtab.siege ? 'bi-check-circle' : ''} fs-5`}
                                  style={{color: 'green'}}
                                ></i>
                              </td>
                              <td>{clientEtab.siret || '—'}</td>
                              <td>{clientEtab.nic || '—'}</td>
                              <td>{clientEtab.numeroVoie || '—'}</td>
                              <td>{clientEtab.typeVoie || '—'}</td>
                              <td>{clientEtab.complementAdresse || '—'}</td>
                              <td>{clientEtab.adresseLigne1 || '—'}</td>
                              <td>{clientEtab.adresseLigne2 || '—'}</td>
                              <td>{clientEtab.codePostal || '—'}</td>
                              <td>{clientEtab.ville || '—'}</td>
                              <td>{clientEtab.codeNaf || '—'}</td>
                              <td>{clientEtab.etablissement || '—'}</td>
                              <td>{clientEtab.libelleCodeNaf || '—'}</td>
                              <td>
                                {clientEtab.dateCreation
                                  ? moment(clientEtab.dateCreation).format('DD/MM/YYYY')
                                  : '—'}
                              </td>
                            </tr>
                          )
                        })
                      ) : (
                        <tr>
                          <td colSpan={12} className='text-center'>
                            Aucun résultat trouvé
                          </td>
                        </tr>
                      )}
                    </tbody>
                    {/* end::Table body */}
                  </table>
                  {/* end::Table */}
                </div>
                {/* end::Table container */}
                {/* begin::pagination*/}
                <Pagination
                  totalPages={totalPages}
                  nombreDePages={nombreDePages}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  locationState={0}
                />
                {/* end::pagination*/}
                {/*Affichage du tooltip*/}
                <Tooltip id='tooltip' />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export {ClientEtablissements}
